import React from 'react';
import { ProductCardContainerStyled } from './bundle.esm3.js';
import ProductCardUI from './bundle.esm4.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const { Description, Image, Name } = ProductCardUI;
const ProductCard = (props) => {
  const { product, placeholder, width = "100%", height = "100%" } = props;
  if (!product) {
    return placeholder ? /* @__PURE__ */ React.createElement(ProductCardContainerStyled, {
      width,
      height
    }, placeholder) : /* @__PURE__ */ React.createElement("div", null);
  }
  return /* @__PURE__ */ React.createElement(ProductCardContainerStyled, {
    width,
    height
  }, /* @__PURE__ */ React.createElement(ProductCardUI, __spreadValues({}, props)));
};
ProductCard.Description = Description;
ProductCard.Image = Image;
ProductCard.Name = Name;
ProductCard.defaultProps = {
  width: "100%",
  height: "initial"
};

export { ProductCard as default };
//# sourceMappingURL=bundle.esm.js.map
